/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { ExportPlayersStatsCsvParams } from '../_model/exportPlayersStatsCsvParams';
import type { GetOverallPlayersStatsParams } from '../_model/getOverallPlayersStatsParams';
import type { GetOverallQuizzesStatsParams } from '../_model/getOverallQuizzesStatsParams';
import type { GetOverallStatsParams } from '../_model/getOverallStatsParams';
import type { GetPlayerDetailStatsByLtiUserParams } from '../_model/getPlayerDetailStatsByLtiUserParams';
import type { GetPlayerDetailStatsParams } from '../_model/getPlayerDetailStatsParams';
import type { GetPlayersStatsParams } from '../_model/getPlayersStatsParams';
import type { GetQuizPlayersStatsParams } from '../_model/getQuizPlayersStatsParams';
import type { GetQuizzesDetailStatsParams } from '../_model/getQuizzesDetailStatsParams';
import type { GetQuizzesStatsParams } from '../_model/getQuizzesStatsParams';
import type { QuizsetStatsPlayersRequest } from '../_model/quizsetStatsPlayersRequest';
import type { StreamingResponseBody } from '../_model/streamingResponseBody';
import type { SuccessBodyListQuizDetailStatsResponse } from '../_model/successBodyListQuizDetailStatsResponse';
import type { SuccessBodyListQuizsetStatsQuizzesResponse } from '../_model/successBodyListQuizsetStatsQuizzesResponse';
import type { SuccessBodyQuizPlayersPageResponse } from '../_model/successBodyQuizPlayersPageResponse';
import type { SuccessBodyQuizsetStatsOverallPlayersResponse } from '../_model/successBodyQuizsetStatsOverallPlayersResponse';
import type { SuccessBodyQuizsetStatsOverallQuizzesResponse } from '../_model/successBodyQuizsetStatsOverallQuizzesResponse';
import type { SuccessBodyQuizsetStatsOverallResponse } from '../_model/successBodyQuizsetStatsOverallResponse';
import type { SuccessBodyQuizsetStatsPlayerDetailResponse } from '../_model/successBodyQuizsetStatsPlayerDetailResponse';
import type { SuccessBodyQuizsetStatsPlayersResponse } from '../_model/successBodyQuizsetStatsPlayersResponse';
import type { SuccessBodyQuizsetStatsPlayersTop100Response } from '../_model/successBodyQuizsetStatsPlayersTop100Response';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPlayersStatsTop100 = (
  quizsetStatsPlayersRequest: BodyType<QuizsetStatsPlayersRequest>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetStatsPlayersTop100Response>(
    {
      url: `/quizset-stats/players/top100`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetStatsPlayersRequest,
      signal,
    },
    options,
  );
};

export const getGetPlayersStatsTop100MutationKey = () =>
  ['getPlayersStatsTop100'] as const;

export const getGetPlayersStatsTop100MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPlayersStatsTop100>>,
    TError,
    GetPlayersStatsTop100MutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPlayersStatsTop100>>,
  TError,
  GetPlayersStatsTop100MutationVariables,
  TContext
> => {
  const mutationKey = getGetPlayersStatsTop100MutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPlayersStatsTop100>>,
    GetPlayersStatsTop100MutationVariables
  > = props => {
    const { data } = props ?? {};

    return getPlayersStatsTop100(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPlayersStatsTop100MutationResult = NonNullable<
  Awaited<ReturnType<typeof getPlayersStatsTop100>>
>;
export type GetPlayersStatsTop100MutationBody =
  BodyType<QuizsetStatsPlayersRequest>;
export type GetPlayersStatsTop100MutationError = ErrorType<unknown>;
export type GetPlayersStatsTop100MutationVariables = {
  data: BodyType<QuizsetStatsPlayersRequest>;
};

export const useGetPlayersStatsTop100 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getPlayersStatsTop100>>,
      TError,
      GetPlayersStatsTop100MutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getPlayersStatsTop100>>,
  TError,
  GetPlayersStatsTop100MutationVariables,
  TContext
> => {
  return useMutation(
    getGetPlayersStatsTop100MutationOptions(options),
    queryClient,
  );
};
export const getQuizzesStats = (
  params: GetQuizzesStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListQuizsetStatsQuizzesResponse>(
    { url: `/quizset-stats/quizzes`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizzesStatsQueryKey = (params?: GetQuizzesStatsParams) => {
  return [`/quizset-stats/quizzes`, ...(params ? [params] : [])] as const;
};

export const getGetQuizzesStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizzesStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizzesStats>>> = ({
    signal,
  }) => getQuizzesStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizzesStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizzesStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizzesStats>>
>;
export type GetQuizzesStatsQueryError = ErrorType<unknown>;

export function useGetQuizzesStats<
  TData = Awaited<ReturnType<typeof getQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizzesStats>>,
          TError,
          Awaited<ReturnType<typeof getQuizzesStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizzesStats<
  TData = Awaited<ReturnType<typeof getQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizzesStats>>,
          TError,
          Awaited<ReturnType<typeof getQuizzesStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizzesStats<
  TData = Awaited<ReturnType<typeof getQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizzesStats<
  TData = Awaited<ReturnType<typeof getQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizzesStatsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizzesStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizzesStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizzesStats>>> = ({
    signal,
  }) => getQuizzesStats(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizzesStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizzesStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizzesStats>>
>;
export type GetQuizzesStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizzesStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizzesStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizzesStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizzesStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizzesStatsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getQuizzesDetailStats = (
  params: GetQuizzesDetailStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListQuizDetailStatsResponse>(
    { url: `/quizset-stats/quizzes-detail`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizzesDetailStatsQueryKey = (
  params?: GetQuizzesDetailStatsParams,
) => {
  return [
    `/quizset-stats/quizzes-detail`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetQuizzesDetailStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizzesDetailStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesDetailStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizzesDetailStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizzesDetailStats>>
  > = ({ signal }) => getQuizzesDetailStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizzesDetailStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizzesDetailStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizzesDetailStats>>
>;
export type GetQuizzesDetailStatsQueryError = ErrorType<unknown>;

export function useGetQuizzesDetailStats<
  TData = Awaited<ReturnType<typeof getQuizzesDetailStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesDetailStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesDetailStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizzesDetailStats>>,
          TError,
          Awaited<ReturnType<typeof getQuizzesDetailStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizzesDetailStats<
  TData = Awaited<ReturnType<typeof getQuizzesDetailStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesDetailStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesDetailStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizzesDetailStats>>,
          TError,
          Awaited<ReturnType<typeof getQuizzesDetailStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizzesDetailStats<
  TData = Awaited<ReturnType<typeof getQuizzesDetailStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesDetailStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizzesDetailStats<
  TData = Awaited<ReturnType<typeof getQuizzesDetailStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesDetailStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizzesDetailStatsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizzesDetailStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizzesDetailStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesDetailStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizzesDetailStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizzesDetailStats>>
  > = ({ signal }) => getQuizzesDetailStats(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizzesDetailStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizzesDetailStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizzesDetailStats>>
>;
export type GetQuizzesDetailStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizzesDetailStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizzesDetailStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesDetailStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizzesDetailStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizzesDetailStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesDetailStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizzesDetailStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizzesDetailStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesDetailStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizzesDetailStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizzesDetailStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizzesDetailStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizzesDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizzesDetailStatsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getQuizPlayersStats = (
  params: GetQuizPlayersStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizPlayersPageResponse>(
    { url: `/quizset-stats/quiz-players`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizPlayersStatsQueryKey = (
  params?: GetQuizPlayersStatsParams,
) => {
  return [`/quizset-stats/quiz-players`, ...(params ? [params] : [])] as const;
};

export const getGetQuizPlayersStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizPlayersStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizPlayersStats>>
  > = ({ signal }) => getQuizPlayersStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizPlayersStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizPlayersStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizPlayersStats>>
>;
export type GetQuizPlayersStatsQueryError = ErrorType<unknown>;

export function useGetQuizPlayersStats<
  TData = Awaited<ReturnType<typeof getQuizPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlayersStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlayersStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizPlayersStats>>,
          TError,
          Awaited<ReturnType<typeof getQuizPlayersStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizPlayersStats<
  TData = Awaited<ReturnType<typeof getQuizPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlayersStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizPlayersStats>>,
          TError,
          Awaited<ReturnType<typeof getQuizPlayersStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizPlayersStats<
  TData = Awaited<ReturnType<typeof getQuizPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizPlayersStats<
  TData = Awaited<ReturnType<typeof getQuizPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizPlayersStatsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizPlayersStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizPlayersStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizPlayersStats>>
  > = ({ signal }) => getQuizPlayersStats(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizPlayersStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizPlayersStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizPlayersStats>>
>;
export type GetQuizPlayersStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlayersStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getQuizPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizPlayersStatsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPlayersStats = (
  params: GetPlayersStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetStatsPlayersResponse>(
    { url: `/quizset-stats/players`, method: 'GET', params, signal },
    options,
  );
};

export const getGetPlayersStatsQueryKey = (params?: GetPlayersStatsParams) => {
  return [`/quizset-stats/players`, ...(params ? [params] : [])] as const;
};

export const getGetPlayersStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlayersStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayersStats>>> = ({
    signal,
  }) => getPlayersStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlayersStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlayersStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayersStats>>
>;
export type GetPlayersStatsQueryError = ErrorType<unknown>;

export function useGetPlayersStats<
  TData = Awaited<ReturnType<typeof getPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayersStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayersStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayersStats>>,
          TError,
          Awaited<ReturnType<typeof getPlayersStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayersStats<
  TData = Awaited<ReturnType<typeof getPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayersStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayersStats>>,
          TError,
          Awaited<ReturnType<typeof getPlayersStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayersStats<
  TData = Awaited<ReturnType<typeof getPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPlayersStats<
  TData = Awaited<ReturnType<typeof getPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPlayersStatsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPlayersStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlayersStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayersStats>>> = ({
    signal,
  }) => getPlayersStats(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlayersStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetPlayersStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayersStats>>
>;
export type GetPlayersStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayersStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPlayersStatsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPlayerDetailStats = (
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetStatsPlayerDetailResponse>(
    {
      url: `/quizset-stats/players/${playerHashId}`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetPlayerDetailStatsQueryKey = (
  playerHashId: string,
  params?: GetPlayerDetailStatsParams,
) => {
  return [
    `/quizset-stats/players/${playerHashId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlayerDetailStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayerDetailStats>>,
  TError = ErrorType<unknown>,
>(
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlayerDetailStatsQueryKey(playerHashId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlayerDetailStats>>
  > = ({ signal }) =>
    getPlayerDetailStats(playerHashId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: playerHashId !== null && playerHashId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlayerDetailStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlayerDetailStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayerDetailStats>>
>;
export type GetPlayerDetailStatsQueryError = ErrorType<unknown>;

export function useGetPlayerDetailStats<
  TData = Awaited<ReturnType<typeof getPlayerDetailStats>>,
  TError = ErrorType<unknown>,
>(
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerDetailStats>>,
          TError,
          Awaited<ReturnType<typeof getPlayerDetailStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayerDetailStats<
  TData = Awaited<ReturnType<typeof getPlayerDetailStats>>,
  TError = ErrorType<unknown>,
>(
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerDetailStats>>,
          TError,
          Awaited<ReturnType<typeof getPlayerDetailStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayerDetailStats<
  TData = Awaited<ReturnType<typeof getPlayerDetailStats>>,
  TError = ErrorType<unknown>,
>(
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPlayerDetailStats<
  TData = Awaited<ReturnType<typeof getPlayerDetailStats>>,
  TError = ErrorType<unknown>,
>(
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPlayerDetailStatsQueryOptions(
    playerHashId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPlayerDetailStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayerDetailStats>>,
  TError = ErrorType<unknown>,
>(
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlayerDetailStatsQueryKey(playerHashId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlayerDetailStats>>
  > = ({ signal }) =>
    getPlayerDetailStats(playerHashId, params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlayerDetailStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetPlayerDetailStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayerDetailStats>>
>;
export type GetPlayerDetailStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetPlayerDetailStatsSuspense<
  TData = Awaited<ReturnType<typeof getPlayerDetailStats>>,
  TError = ErrorType<unknown>,
>(
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayerDetailStatsSuspense<
  TData = Awaited<ReturnType<typeof getPlayerDetailStats>>,
  TError = ErrorType<unknown>,
>(
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayerDetailStatsSuspense<
  TData = Awaited<ReturnType<typeof getPlayerDetailStats>>,
  TError = ErrorType<unknown>,
>(
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPlayerDetailStatsSuspense<
  TData = Awaited<ReturnType<typeof getPlayerDetailStats>>,
  TError = ErrorType<unknown>,
>(
  playerHashId: string,
  params: GetPlayerDetailStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPlayerDetailStatsSuspenseQueryOptions(
    playerHashId,
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const exportPlayersStatsCsv = (
  params: ExportPlayersStatsCsvParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<StreamingResponseBody>(
    { url: `/quizset-stats/players/csv`, method: 'GET', params, signal },
    options,
  );
};

export const getExportPlayersStatsCsvQueryKey = (
  params?: ExportPlayersStatsCsvParams,
) => {
  return [`/quizset-stats/players/csv`, ...(params ? [params] : [])] as const;
};

export const getExportPlayersStatsCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
  TError = ErrorType<unknown>,
>(
  params: ExportPlayersStatsCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportPlayersStatsCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportPlayersStatsCsv>>
  > = ({ signal }) => exportPlayersStatsCsv(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportPlayersStatsCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportPlayersStatsCsv>>
>;
export type ExportPlayersStatsCsvQueryError = ErrorType<unknown>;

export function useExportPlayersStatsCsv<
  TData = Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
  TError = ErrorType<unknown>,
>(
  params: ExportPlayersStatsCsvParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
          TError,
          Awaited<ReturnType<typeof exportPlayersStatsCsv>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportPlayersStatsCsv<
  TData = Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
  TError = ErrorType<unknown>,
>(
  params: ExportPlayersStatsCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
          TError,
          Awaited<ReturnType<typeof exportPlayersStatsCsv>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportPlayersStatsCsv<
  TData = Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
  TError = ErrorType<unknown>,
>(
  params: ExportPlayersStatsCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useExportPlayersStatsCsv<
  TData = Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
  TError = ErrorType<unknown>,
>(
  params: ExportPlayersStatsCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportPlayersStatsCsvQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getExportPlayersStatsCsvSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
  TError = ErrorType<unknown>,
>(
  params: ExportPlayersStatsCsvParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportPlayersStatsCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportPlayersStatsCsv>>
  > = ({ signal }) => exportPlayersStatsCsv(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type ExportPlayersStatsCsvSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportPlayersStatsCsv>>
>;
export type ExportPlayersStatsCsvSuspenseQueryError = ErrorType<unknown>;

export function useExportPlayersStatsCsvSuspense<
  TData = Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
  TError = ErrorType<unknown>,
>(
  params: ExportPlayersStatsCsvParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportPlayersStatsCsvSuspense<
  TData = Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
  TError = ErrorType<unknown>,
>(
  params: ExportPlayersStatsCsvParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportPlayersStatsCsvSuspense<
  TData = Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
  TError = ErrorType<unknown>,
>(
  params: ExportPlayersStatsCsvParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useExportPlayersStatsCsvSuspense<
  TData = Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
  TError = ErrorType<unknown>,
>(
  params: ExportPlayersStatsCsvParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof exportPlayersStatsCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportPlayersStatsCsvSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPlayerDetailStatsByLtiUser = (
  params: GetPlayerDetailStatsByLtiUserParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetStatsPlayerDetailResponse>(
    {
      url: `/quizset-stats/players/by-lti-user`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetPlayerDetailStatsByLtiUserQueryKey = (
  params?: GetPlayerDetailStatsByLtiUserParams,
) => {
  return [
    `/quizset-stats/players/by-lti-user`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlayerDetailStatsByLtiUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayerDetailStatsByLtiUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlayerDetailStatsByLtiUserQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>
  > = ({ signal }) =>
    getPlayerDetailStatsByLtiUser(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlayerDetailStatsByLtiUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>
>;
export type GetPlayerDetailStatsByLtiUserQueryError = ErrorType<unknown>;

export function useGetPlayerDetailStatsByLtiUser<
  TData = Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayerDetailStatsByLtiUserParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
          TError,
          Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayerDetailStatsByLtiUser<
  TData = Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayerDetailStatsByLtiUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
          TError,
          Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayerDetailStatsByLtiUser<
  TData = Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayerDetailStatsByLtiUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPlayerDetailStatsByLtiUser<
  TData = Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayerDetailStatsByLtiUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPlayerDetailStatsByLtiUserQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPlayerDetailStatsByLtiUserSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayerDetailStatsByLtiUserParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlayerDetailStatsByLtiUserQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>
  > = ({ signal }) =>
    getPlayerDetailStatsByLtiUser(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetPlayerDetailStatsByLtiUserSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>
>;
export type GetPlayerDetailStatsByLtiUserSuspenseQueryError =
  ErrorType<unknown>;

export function useGetPlayerDetailStatsByLtiUserSuspense<
  TData = Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayerDetailStatsByLtiUserParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayerDetailStatsByLtiUserSuspense<
  TData = Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayerDetailStatsByLtiUserParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlayerDetailStatsByLtiUserSuspense<
  TData = Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayerDetailStatsByLtiUserParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPlayerDetailStatsByLtiUserSuspense<
  TData = Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlayerDetailStatsByLtiUserParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlayerDetailStatsByLtiUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPlayerDetailStatsByLtiUserSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getOverallStats = (
  params: GetOverallStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetStatsOverallResponse>(
    { url: `/quizset-stats/overall`, method: 'GET', params, signal },
    options,
  );
};

export const getGetOverallStatsQueryKey = (params?: GetOverallStatsParams) => {
  return [`/quizset-stats/overall`, ...(params ? [params] : [])] as const;
};

export const getGetOverallStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOverallStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOverallStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverallStats>>> = ({
    signal,
  }) => getOverallStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOverallStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOverallStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOverallStats>>
>;
export type GetOverallStatsQueryError = ErrorType<unknown>;

export function useGetOverallStats<
  TData = Awaited<ReturnType<typeof getOverallStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverallStats>>,
          TError,
          Awaited<ReturnType<typeof getOverallStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallStats<
  TData = Awaited<ReturnType<typeof getOverallStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverallStats>>,
          TError,
          Awaited<ReturnType<typeof getOverallStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallStats<
  TData = Awaited<ReturnType<typeof getOverallStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOverallStats<
  TData = Awaited<ReturnType<typeof getOverallStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOverallStatsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOverallStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOverallStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOverallStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverallStats>>> = ({
    signal,
  }) => getOverallStats(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOverallStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetOverallStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOverallStats>>
>;
export type GetOverallStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetOverallStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOverallStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOverallStatsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getOverallQuizzesStats = (
  params: GetOverallQuizzesStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetStatsOverallQuizzesResponse>(
    { url: `/quizset-stats/overall/quizzes`, method: 'GET', params, signal },
    options,
  );
};

export const getGetOverallQuizzesStatsQueryKey = (
  params?: GetOverallQuizzesStatsParams,
) => {
  return [
    `/quizset-stats/overall/quizzes`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOverallQuizzesStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOverallQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOverallQuizzesStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOverallQuizzesStats>>
  > = ({ signal }) => getOverallQuizzesStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOverallQuizzesStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOverallQuizzesStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOverallQuizzesStats>>
>;
export type GetOverallQuizzesStatsQueryError = ErrorType<unknown>;

export function useGetOverallQuizzesStats<
  TData = Awaited<ReturnType<typeof getOverallQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallQuizzesStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallQuizzesStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverallQuizzesStats>>,
          TError,
          Awaited<ReturnType<typeof getOverallQuizzesStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallQuizzesStats<
  TData = Awaited<ReturnType<typeof getOverallQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallQuizzesStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverallQuizzesStats>>,
          TError,
          Awaited<ReturnType<typeof getOverallQuizzesStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallQuizzesStats<
  TData = Awaited<ReturnType<typeof getOverallQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOverallQuizzesStats<
  TData = Awaited<ReturnType<typeof getOverallQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOverallQuizzesStatsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOverallQuizzesStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOverallQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOverallQuizzesStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOverallQuizzesStats>>
  > = ({ signal }) => getOverallQuizzesStats(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOverallQuizzesStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetOverallQuizzesStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOverallQuizzesStats>>
>;
export type GetOverallQuizzesStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetOverallQuizzesStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallQuizzesStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallQuizzesStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallQuizzesStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOverallQuizzesStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallQuizzesStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallQuizzesStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallQuizzesStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOverallQuizzesStatsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getOverallPlayersStats = (
  params: GetOverallPlayersStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetStatsOverallPlayersResponse>(
    { url: `/quizset-stats/overall/players`, method: 'GET', params, signal },
    options,
  );
};

export const getGetOverallPlayersStatsQueryKey = (
  params?: GetOverallPlayersStatsParams,
) => {
  return [
    `/quizset-stats/overall/players`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOverallPlayersStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOverallPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOverallPlayersStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOverallPlayersStats>>
  > = ({ signal }) => getOverallPlayersStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOverallPlayersStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOverallPlayersStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOverallPlayersStats>>
>;
export type GetOverallPlayersStatsQueryError = ErrorType<unknown>;

export function useGetOverallPlayersStats<
  TData = Awaited<ReturnType<typeof getOverallPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallPlayersStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallPlayersStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverallPlayersStats>>,
          TError,
          Awaited<ReturnType<typeof getOverallPlayersStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallPlayersStats<
  TData = Awaited<ReturnType<typeof getOverallPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallPlayersStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverallPlayersStats>>,
          TError,
          Awaited<ReturnType<typeof getOverallPlayersStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallPlayersStats<
  TData = Awaited<ReturnType<typeof getOverallPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOverallPlayersStats<
  TData = Awaited<ReturnType<typeof getOverallPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallPlayersStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOverallPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOverallPlayersStatsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOverallPlayersStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOverallPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOverallPlayersStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOverallPlayersStats>>
  > = ({ signal }) => getOverallPlayersStats(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOverallPlayersStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetOverallPlayersStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOverallPlayersStats>>
>;
export type GetOverallPlayersStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetOverallPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallPlayersStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOverallPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOverallPlayersStatsSuspense<
  TData = Awaited<ReturnType<typeof getOverallPlayersStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetOverallPlayersStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOverallPlayersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOverallPlayersStatsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
